import { Icon } from "materia"
import type { ComponentProps } from "react"
import { modifiers } from "ui-tools"
import s from "./styles.module.scss"

type IconCertifiedProps = Omit<ComponentProps<typeof Icon>, "icon">
export const IconCertified = ({ className, ...props }: IconCertifiedProps) => {
  return (
    <Icon
      icon="CheckmarkCircle"
      className={`${modifiers(s, "certifiedIcon")} ${className}`}
      {...props}
    />
  )
}
